<template>
  <img
    src="/logo.png"
    alt="Logo"
    width="40"
    height="40"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
